import { notificationRecipientService } from '_services';
import { session } from '_helpers';
import { ACTIONS_RECIPIENT } from '_constants/notificationRecipient.constants';
import alertActions from './alert.actions';

export const receiveRecipients = (recipients) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < recipients.length; i++) {
    byIdObjectToDispatch[recipients[i].alertEmailID] = recipients[i];
  }

  return {
    type: ACTIONS_RECIPIENT.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteRecipient = (alertEmailID) => ({
  type: ACTIONS_RECIPIENT.DELETE,
  byId: { [alertEmailID]: null }
});

const getRecipients = (accountID) => async (dispatch) => {
  try {
    const resp = await notificationRecipientService.getAll(accountID);
    if (resp?.[0]?.alertEmailID) {
      dispatch(receiveRecipients(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving recipients.', e));
  }
  return null;
};

const getRecipient = (alertEmailID) => async (dispatch) => {
  try {
    const resp = await notificationRecipientService.getById(alertEmailID);
    if (resp?.alertEmailID) {
      dispatch(receiveRecipients([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving recipient #${alertEmailID}.`, e));
  }
  return null;
};

const addRecipient = (recipients, accountID) => async (dispatch) => {
  try {
    const resp = await notificationRecipientService.create(recipients, accountID);
    if (resp?.[0]?.alertEmailID) {
      dispatch(receiveRecipients(resp));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updRecipient = (recipients, accountID) => async (dispatch) => {
  try {
    const resp = await notificationRecipientService.update(recipients, accountID);
    if (resp?.[0]?.alertEmailID) {
      dispatch(receiveRecipients(resp));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const delRecipient = (recipients) => async (dispatch) => {
  try {
    const resp = await notificationRecipientService.delete(recipients);
    if (resp?.alertEmailID) {
      dispatch(deleteRecipient(resp.alertEmailID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error removing recipients.', e));
  }
  return null;
};

const recipientActions = {
  getRecipients,
  getRecipient,
  addRecipient,
  updRecipient,
  delRecipient
};

export default recipientActions;
